import { type PromotionPlanExport } from '@onr/schema'

import { useOnrApi } from '@/api/mutation/useOnrApi'

export function usePromotionPlanExport() {
  return useOnrApi<string, PromotionPlanExport>({
    type: 'promotionPlanExport',
  })
}
